import '../scss/style.scss';

// Import global variables and helpers.
import g_Variable from './global/GlobalVariables';

// Import plugins.
import p_jsCookie from "./plugins/jsCookie";
import p_jsLightbox2 from "./plugins/jsLightbox2";

// Import modules
import collapseContent from "./modules/collapseContent";
import slickSlider from "./modules/slickSlider";
import groupLinkDropdownMenu from "./modules/groupLinkDropdownMenu";
import formReset from "./modules/formReset";
import webformResetButton from "./modules/webformResetButton";
import recentInformationBlocks from "./modules/recentInformationBlocks";
import recentTopicsBlocks from "./modules/recentTopicsBlocks";
import webformFileUpload from "./modules/webformFileUpload";
import navigation from "./modules/navigation";
import imageCaption from "./modules/imageCaption";
import video from "./modules/video";
import taxRates from "./modules/taxRates";
import nsSteps from "./modules/nsSteps";
import protectedContent from "./modules/protectedContent";
import tableWrap from "./modules/tableWrap";
import responsiveSubmenuToggle from "./modules/responsiveSubmenuToggle";
import nrwMap from "./modules/nrwMap";
import accessibleLinks from "./modules/accessibleLinks";
import searchResults from "./modules/searchResults";
import select2A11y from "./modules/select2A11y";
import accessibleTags from "./modules/accessibleTags";
import webformAccessibility from "./modules/webformAccessibility";
import sitemapBlock from "./modules/sitemapBlock";
import securitiesSearchTableLabels from "./modules/securitiesSearchTableLabels";
import coworkingMap from "./modules/coworkingMap";
import eyeAblePositionFix from "./modules/eyeAblePositionFix";

(function ($, Drupal, drupalSettings) {
    /**
     * WEBPACK .ENV SETTINGS
     */
    if (process.env.production === 'false') {
    //    console.log('%c --- Webpack configuration ---', 'background: #fff; color: #ff006e');
    //    console.log('%c Webpack is running in the DEVELOPMENT MODE, keep going!', 'background: #fff; color: #ff006e');
    }

    /**
     * Global variables
     */
    //console.log(`Global variable executed is set to: ${ g_Variable.executed }`);

    /**
     * Plugin JS cookie
     * @type {{addCookie, removeCookie, getCookie, getAllCookie}}
     */
    Drupal.behaviors.jsCookie = p_jsCookie;

    /**
     * Example of drupal behavior.
     * @type {{
     *  attach: Drupal.behaviors.customMethod.attach,
     *  init: Drupal.behaviors.customMethod.init
     * }}
     */
    Drupal.behaviors.customMethod = {
        attach: function (context, settings) {
            let $newContent = $(context);

            if ($newContent.find('body').length > 0) {
                Drupal.behaviors.customMethod.init();
            }
        },
        init: function() {
            // Cookie test
            /*
            Drupal.behaviors.jsCookie.addCookie('d9_test', 'This is the best Drupal 9 theme!');
            let getCookie = Drupal.behaviors.jsCookie.getCookie('d9_test');
            */

            //console.log(`Here are the value of a stored cookie: ${getCookie}`);
        },
        // other custom functions
    }

    /**
     * Collapse content (Accordion)
     * @type {{attach, init}}
     */
    Drupal.behaviors.collapseContent = collapseContent;

  /**
   * Slick slider initialization.
   * @type {{
   *  initSlickSlider: function(*): void,
   *  attach: function(*=, *): void
   *  }}
   */
  Drupal.behaviors.slickSlider = slickSlider;

  /**
   * Dropbutton links - add bootstrap collapse attribuets.
   * @type {{attach: function(*=, *): void, dropbuttonInit: function(*, *=): void}}
   */
  Drupal.behaviors.groupLinkDropdownMenu = groupLinkDropdownMenu;

  /**
   * Form reset on submission forms.
   * @type {{setEventListener: function(*): void, attach: function(*=, *): void}}
   */
  Drupal.behaviors.formReset = formReset;

  /**
   * Remove reset-button on webform preview page.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.webFormResetButton = webformResetButton;

  /**
   * Remove "Hochladen"-Button, if Javascript is active
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.webformFileUpload = webformFileUpload;

  /**
   * Manipulating entity references in Recent Information Region.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.recentInformationBlocks = recentInformationBlocks;

  /**
   * Manipulating links in Recent Topics Region.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.recentTopicsBlocks = recentTopicsBlocks;

  /**
   * updating navigation to work with screen readers properly
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.navigation = navigation;

  /**
   * Image caption width.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.imageCaption = imageCaption;

  Drupal.behaviors.jsLightbox2 = p_jsLightbox2;

  /**
   * Remove tabindex from video player wrapper
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.video = video;

  /**
   * Tax rates logic.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.taxRates = taxRates;

  /**
   * nsSteps.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.nsSteps = nsSteps;

  /**
   * Protected content logic.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.protectedContent = protectedContent;

  /**
   * Table wrap.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.tableWrap = tableWrap;

  /**
   * Toggle for mobile submenu.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.responsiveSubmenuToggle = responsiveSubmenuToggle;

  /**
   * Accessibility for NRW map.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.nrwMap = nrwMap;

  /**
   * Accessibility for links.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.accessibleLinks = accessibleLinks;

  /**
   * Accessibility for search results.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.searchResults = searchResults;

  /**
   * Accessibility for select2.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.select2A11y = select2A11y;

  /**
   * Accessibility for tags.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.accessibleTags = accessibleTags;

  /**
   * Webform accessibility.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.webformAccessibility = webformAccessibility;

  /**
   * Sitemap toggle and accessibility.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.sitemapBlock = sitemapBlock;

  /**
   * Labels for mobile view of the securities search table.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.securitiesSearchTableLabels = securitiesSearchTableLabels;

  /**
   * Coworking map.
   * @type {{attach: function(*=, *): void}}
   */
  Drupal.behaviors.coworkingMap = coworkingMap;

  /**
   * Eye-Able position fix.
   * @type {{attach: function(*, *): void}}
   */
  Drupal.behaviors.eyeAblePositionFix = eyeAblePositionFix;

  /**
   * LEAVE IT AT THE BOTTOM OF THE SCRIPT.
   * Set executed variable to true.
   */
  if (!g_Variable.executed) {
      g_Variable.setExecuted(true);
  }

}) (jQuery, window.Drupal, drupalSettings);
